import { t } from '@lingui/core/macro';
import { httpUrlOrUndefined } from '@luminovo/commons';
import { SecondaryIconButton } from '@luminovo/design-system';
import { FileTextIcon } from 'lucide-react';
import { type JSX, useCallback } from 'react';

export const DatasheetIconButton = ({ url }: { url: string }): JSX.Element => {
    const handleClick = useCallback(
        (e: React.MouseEvent<HTMLButtonElement>) => {
            e.stopPropagation();
            const safeUrl = httpUrlOrUndefined(url);
            if (!safeUrl) {
                return;
            }
            window.open(safeUrl, '_blank', 'noopener,noreferrer');
        },
        [url],
    );

    return (
        <SecondaryIconButton size="small" aria-label={t`Open datasheet`} onClick={handleClick}>
            <FileTextIcon />
        </SecondaryIconButton>
    );
};
